import { TableQuestionIcon } from './TableQuestionIcon';

/**
 * author: Andrej Sharapov
 * id DD9EA6CC-9992-418C-8664-2254FC64A41F
 * name table-question
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-question.svg
 * tags
 */
export const TableHelpIcon = TableQuestionIcon;
export default TableHelpIcon